import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import {
  BaseControl,
  Textbox,
  Dropdown,
  EspacioControl,
  Control,
  TablaMaestra,
  DateTimePicker,
  Custom,
  Container,
  SubForma,
  Legend,
  Option,
} from "@app/shared";
import { environment } from "@env/environment";

@Injectable()
export class CreationFormsFormService {
  table = false;

  constructor() { }

  /**
   * Setea la data del combo de los tipos de tamaños de los controles
   *
   * @param {Array<EspacioControl>} sizesControl
   * @returns {Array<any>}
   * @memberof CreationFormsFormService
   */
  setSizes(sizesControl: Array<EspacioControl>): Array<any> {
    const sizes: Array<any> = [];
    sizesControl.forEach((size) => {
      sizes.push({
        key: size.espacio,
        value: size.nombre,
      });
    });
    return sizes;
  }

  /**
   * setea la data para el combo de lista de maestras para los controles
   *
   * @param {Array<TablaMaestra>} masterTables
   * @returns {Array<any>}
   * @memberof CreationFormsFormService
   */
  setMasterTables(masterTables: Array<TablaMaestra>): Array<any> {
    const masterT: Array<any> = [];
    masterTables.forEach((mt) => {
      masterT.push({
        key: mt.id,
        value: mt.nombre,
      });
    });
    return masterT;
  }

  /**
   * setea la data para el combo de lista simple para los controles
   *
   * @param {Array<any>} masterTables
   * @returns {Array<any>}
   * @memberof CreationFormsFormService
   */
  setMapSearch(data: Array<any>): Array<any> {
    const dataResult: Array<any> = [];
    data.forEach((d) => {
      dataResult.push({
        key: d.id,
        value: d.nombre,
      });
    });
    return dataResult;
  }

  /**
   * Crea el formulario para la creacion de los controles de tipo input
   *
   * @param {Array<EspacioControl>} sizesControl
   * @param {Control} [control]
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormText(sizesControl: Array<EspacioControl>, control?: Control): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: "txtAlias",
        label: "Alias del control:",
        value: control ? control.alias : "",
        describe:
          "Nota: este alias se utiliza como referencia para poder acceder a cada campo del formulario " +
          "y no debe llevar espacios ni caracteres especiales.",
        order: 1,
        placeholder: "Alias del control",
        validations: {
          validators: [Validators.required, Validators.pattern("^[a-zA-Z_]*$")],
          messages: { pattern: "Caracteres invalidos: solo letras y guiones bajos" },
        },
      }),
      new Dropdown({
        key: "cboEspacios",
        label: "Tamaño del control:",
        value: control ? control.espacio : 4,
        options: this.setSizes(sizesControl),
        order: 2,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtLabel",
        label: "Título del control:",
        value: control ? control.label : "",
        order: 3,
        placeholder: "Título del control",
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtPlaceholder",
        label: "Placeholder del control:",
        value: control ? control.placeholder : "",
        order: 4,
        placeholder: "Placeholder del control",
      }),
      new Textbox({
        key: "txtTooltip",
        label: "Tooltip del control:",
        value: control ? control.tooltip : "",
        order: 5,
        placeholder: "Tooltip del control",
      }),
      new Textbox({
        key: "txtMin",
        label: "Caracteres mínimos:",
        value: control ? (control.propiedades["min"] ? control.propiedades["min"] : null) : null,
        type: "number",
        order: 6,
        placeholder: "Caracteres mínimos",
      }),
      new Textbox({
        key: "txtMax",
        label: "Caracteres máximos:",
        value: control ? (control.propiedades["max"] ? control.propiedades["max"] : null) : null,
        type: "number",
        order: 7,
        placeholder: "Caracteres máximos",
      }),
      new Dropdown({
        key: "cboTransform",
        label: "Transformar texto:",
        value: control
          ? control.propiedades
            ? control.propiedades["transform"]
              ? control.propiedades["transform"]
              : "ninguna"
            : "ninguna"
          : "ninguna",
        options: [
          { key: "ninguna", value: "Ninguna transformación" },
          { key: "uppercase", value: "Mayúscula sostenida" },
          { key: "lowercase", value: "Minúscula sostenida" },
        ],
        order: 8,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtExpresion",
        label: "Expresion regular:",
        value: control ? (control.propiedades["expresion"] ? control.propiedades["expresion"] : "") : "",
        order: 9,
        placeholder: "Expresion regular",
      }),
      new Textbox({
        key: "txtErrorExp",
        label: "Mensaje de error:",
        value: control ? (control.propiedades["mensajeExpresion"] ? control.propiedades["mensajeExpresion"] : "") : "",
        order: 10,
        placeholder: "Mensaje de error de la expresion regular",
      }),
      new Textbox({
        key: "txtTamanoColumna",
        label: "Tamaño de columna:",
        value: control ? (control.propiedades["tamano_columna"] ? control.propiedades["tamano_columna"] : null) : null,
        type: "number",
        order: 11,
        placeholder: "Ingrese el tamaño de la columna",
        describe: "El tamaño de la columna sera automatico de no ingresarlo en este campo",
        validations: {
          validators: [Validators.max(100), Validators.min(1)],
          messages: {
            max: "El tamaño de la columna no puede superar el 100%.",
            min: "El tamaño de la columna debe ser mayor al 0%.",
          },
        },
        condictions: [
          {
            campoDepende: "chMostrarEnTabla",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      // Anexo dato radicación
      new Textbox({
        key: "txtRadicacion",
        label: "Dato radicación:",
        value: control ? control.dato_radicacion : "",
        order: 12,
        placeholder: "Dato radicación",
        validations: {
        },
      }),
      // Fin
      new Container({
        class: "form-row",
        order: 13,
        controls: [
          new Textbox({
            key: "chInterno",
            type: "checkbox",
            value: control
              ? control.propiedades["campo_interno"]
                ? control.propiedades["campo_interno"]
                : false
              : false,
            label: "Campo interno",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chRequiered",
            type: "checkbox",
            value: control ? control.requerido : false,
            label: "Requerido",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chBloquear",
            type: "checkbox",
            value: control ? control.propiedades["bloquear"] : false,
            label: "Bloquear",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chReadOnly",
            type: "checkbox",
            value: control ? (control.propiedades["redonly"] ? control.propiedades["redonly"] : false) : false,
            label: "Solo lectura",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chMostrarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["mostrarTabla"]
                ? control.propiedades["mostrarTabla"]
                : false
              : false,
            label: "Mostrar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chModificarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["modificar_tabla"]
                ? control.propiedades["modificar_tabla"]
                : false
              : false,
            label: "Modificar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chSincronizar",
            type: "checkbox",
            value: control ? control.sincronizado : false,
            label: "Sincronizar",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chSinFiltro",
            type: "checkbox",
            value: control ? (control.propiedades["sin_filtro"] ? control.propiedades["sin_filtro"] : false) : false,
            label: "Sin filtro",
            size: this.table ? "col-12 col-md-3" : "",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chUnico",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["unico"] : false) : false,
            label: "Unico registro",
            size: this.table ? "col-12 col-md-3" : "d-none",
          }),
          new Textbox({
            key: "chCampoModificable",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["modificar_campo"] : false) : false,
            label: "Modificar campo",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Asignar valor",
                valorAsignar: false
              },
            ],
          })
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea los campos del formulario para la creacion del control de area de texto
   *
   * @param {Array<EspacioControl>} sizesControl
   * @param {Control} [control]
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormTextArea(sizesControl: Array<EspacioControl>, control?: Control): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: "txtAlias",
        label: "Alias del control:",
        value: control ? control.alias : "",
        describe:
          "Nota: este alias se utiliza como referencia para poder acceder a cada campo del formulario " +
          "y no debe llevar espacios ni caracteres especiales.",
        order: 1,
        placeholder: "Alias del control",
        validations: {
          validators: [Validators.required, Validators.pattern("^[a-zA-Z_]*$")],
          messages: { pattern: "Caracteres invalidos: solo letras y guiones bajos" },
        },
      }),
      new Dropdown({
        key: "cboEspacios",
        label: "Tamaño del control:",
        value: control ? control.espacio : 4,
        options: this.setSizes(sizesControl),
        order: 2,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtLabel",
        label: "Título del control:",
        value: control ? control.label : "",
        order: 3,
        placeholder: "Título del control",
      }),
      new Textbox({
        key: "txtPlaceholder",
        label: "Placeholder del control:",
        value: control ? control.placeholder : "",
        order: 4,
        placeholder: "Placeholder del control",
      }),
      new Textbox({
        key: "txtTooltip",
        label: "Tooltip del control:",
        value: control ? control.tooltip : "",
        order: 5,
        placeholder: "Tooltip del control",
      }),
      new Textbox({
        key: "txtRows",
        label: "Cantidad de líneas:",
        value: control ? (control.propiedades["rows"] ? control.propiedades["rows"] : 1) : 1,
        type: "number",
        order: 6,
        placeholder: "Cantidad de líneas",
        validations: {
          validators: [Validators.required, Validators.min(1)],
          messages: { min: "Las lineas del campo deben ser superiores a 0." },
        },
      }),
      new Textbox({
        key: "txtMin",
        label: "Caracteres mínimos:",
        value: control ? (control.propiedades["min"] ? control.propiedades["min"] : null) : null,
        type: "number",
        order: 7,
        placeholder: "Caracteres mínimos",
      }),
      new Textbox({
        key: "txtMax",
        label: "Caracteres máximos:",
        value: control ? (control.propiedades["max"] ? control.propiedades["max"] : null) : null,
        type: "number",
        order: 8,
        placeholder: "Caracteres máximos",
      }),
      new Dropdown({
        key: "cboTransform",
        label: "Transformar texto:",
        value: control
          ? control.propiedades
            ? control.propiedades["transform"]
              ? control.propiedades["transform"]
              : "ninguna"
            : "ninguna"
          : "ninguna",
        options: [
          { key: "ninguna", value: "Ninguna transformación" },
          { key: "uppercase", value: "Mayúscula sostenida" },
          { key: "lowercase", value: "Minúscula sostenida" },
        ],
        order: 9,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtTamanoColumna",
        label: "Tamaño de columna:",
        value: control ? (control.propiedades["tamano_columna"] ? control.propiedades["tamano_columna"] : null) : null,
        type: "number",
        order: 10,
        placeholder: "Ingrese el tamaño de la columna",
        describe: "El tamaño de la columna sera automatico de no ingresarlo en este campo",
        validations: {
          validators: [Validators.max(100), Validators.min(1)],
          messages: {
            max: "El tamaño de la columna no puede superar el 100%.",
            min: "El tamaño de la columna debe ser mayor al 0%.",
          },
        },
        condictions: [
          {
            campoDepende: "chMostrarEnTabla",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      // Anexo dato radicación
      new Textbox({
        key: "txtRadicacion",
        label: "Dato radicación",
        value: control ? control.dato_radicacion : "",
        order: 11,
        placeholder: "Dato radicación",
        validations: {
        },
      }),
      //Fin
      new Container({
        class: "form-row",
        order: 12,
        controls: [
          new Textbox({
            key: "chInterno",
            type: "checkbox",
            value: control
              ? control.propiedades["campo_interno"]
                ? control.propiedades["campo_interno"]
                : false
              : false,
            label: "Campo interno",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chRequiered",
            type: "checkbox",
            value: control ? control.requerido : false,
            label: "Requerido",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chBloquear",
            type: "checkbox",
            value: control ? control.propiedades["bloquear"] : false,
            label: "Bloquear",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chReadOnly",
            type: "checkbox",
            value: control ? (control.propiedades["redonly"] ? control.propiedades["redonly"] : false) : false,
            label: "Solo lectura",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chMostrarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["mostrarTabla"]
                ? control.propiedades["mostrarTabla"]
                : false
              : false,
            label: "Mostrar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chModificarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["modificar_tabla"]
                ? control.propiedades["modificar_tabla"]
                : false
              : false,
            label: "Modificar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chSincronizar",
            type: "checkbox",
            value: control ? control.sincronizado : false,
            label: "Sincronizar",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chSinFiltro",
            type: "checkbox",
            value: control ? (control.propiedades["sin_filtro"] ? control.propiedades["sin_filtro"] : false) : false,
            label: "Sin filtro",
            size: this.table ? "col-12 col-md-3" : "",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chUnico",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["unico"] : false) : false,
            label: "Unico registro",
            size: this.table ? "col-12 col-md-3" : "d-none",
          }),
          new Textbox({
            key: "chUsarEditor",
            type: "checkbox",
            value: control && control.propiedades ? control.propiedades["usar_editor"] : false,
            label: "Usar editor",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chCampoModificable",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["modificar_campo"] : false) : false,
            label: "Modificar campo",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Asignar valor",
                valorAsignar: false
              },
            ],
          })
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el formulario de creacion para los controles tipo Check
   *
   * @param {*} templates
   * @param {Control} [control]
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormCheck(templates: any, control?: Control): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Dropdown({
        key: "cboTipoCheckbox",
        label: "Tipo de caja de opcion:",
        value: control
          ? control.propiedades
            ? control.propiedades["tipoCheckbox"]
              ? control.propiedades["tipoCheckbox"]
              : null
            : null
          : null,
        options: [
          { key: "opcionUnica", value: "Opción única" },
          { key: "opcionMultiple", value: "Opción múltiple" },
        ],
        order: 1,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Custom({
        key: "cboGruposCheckbox",
        label: "Grupo de la caja de opcion:",
        placeholder: "Seleccione el grupo al cual pertenece el checkbox",
        value: control
          ? control.propiedades
            ? control.propiedades["grupoCheckbox"]
              ? control.propiedades["grupoCheckbox"]
              : null
            : null
          : null,
        template: templates["ngSelectGruposCheckbox"],
        order: 2,
        validations: {
          validators: [Validators.required],
        },
        condictions: [
          {
            campoDepende: "cboTipoCheckbox",
            siEs: "Igual",
            valor: "opcionMultiple",
            accion: "Mostrar",
          },
        ],
      }),
      new Textbox({
        key: "txtAlias",
        label: "Alias del control:",
        value: control ? control.alias : "",
        describe:
          "Nota: este alias se utiliza como referencia para poder acceder a cada campo del formulario " +
          "y no debe llevar espacios ni caracteres especiales.",
        order: 3,
        placeholder: "Alias del control",
        validations: {
          validators: [Validators.required, Validators.pattern("^[a-zA-Z_]*$")],
          messages: { pattern: "Caracteres invalidos: solo letras y guiones bajos" },
        },
      }),
      new Textbox({
        key: "numFilas",
        label: "Tamaño del control:",
        value: control ? control.espacio : 2,
        order: 4,
        type: "number",
        validations: {
          validators: [Validators.required, Validators.min(2), Validators.max(12)],
          messages: {
            min: "El valor minimo para este campo es de 2",
            max: "El valor maximo para este campo es de 12",
          },
        },
      }),
      new Textbox({
        key: "txtLabel",
        label: "Título del control:",
        value: control ? control.label : "",
        order: 5,
        placeholder: "Título del control",
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtTooltip",
        label: "Tooltip del control:",
        value: control ? control.tooltip : "",
        order: 6,
        placeholder: "Tooltip del control",
      }),
      new Dropdown({
        key: "cboDefault",
        label: "Valor por defecto:",
        value: control
          ? control.propiedades["default"]
            ? control.propiedades["default"]
            : "noSeleccionado"
          : "noSeleccionado",
        options: [
          { key: "seleccionado", value: "Seleccionado" },
          { key: "noSeleccionado", value: "No seleccionado" },
        ],
        order: 7,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtTamanoColumna",
        label: "Tamaño de columna:",
        value: control ? (control.propiedades["tamano_columna"] ? control.propiedades["tamano_columna"] : null) : null,
        type: "number",
        order: 8,
        placeholder: "Ingrese el tamaño de la columna",
        describe: "El tamaño de la columna sera automatico de no ingresarlo en este campo",
        validations: {
          validators: [Validators.max(100), Validators.min(1)],
          messages: {
            max: "El tamaño de la columna no puede superar el 100%.",
            min: "El tamaño de la columna debe ser mayor al 0%.",
          },
        },
        condictions: [
          {
            campoDepende: "chMostrarEnTabla",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      new Container({
        class: "form-row",
        order: 9,
        controls: [
          new Textbox({
            key: "chInterno",
            type: "checkbox",
            value: control
              ? control.propiedades["campo_interno"]
                ? control.propiedades["campo_interno"]
                : false
              : false,
            label: "Campo interno",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chRequiered",
            type: "checkbox",
            value: control ? control.requerido : false,
            label: "Requerido",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "cboTipoCheckbox",
                siEs: "Igual",
                valor: "opcionMultiple",
                accion: "Ocultar",
              },
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chBloquear",
            type: "checkbox",
            value: control ? control.propiedades["bloquear"] : false,
            label: "Bloquear",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chReadOnly",
            type: "checkbox",
            value: control ? (control.propiedades["redonly"] ? control.propiedades["redonly"] : false) : false,
            label: "Solo lectura",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chMostrarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["mostrarTabla"]
                ? control.propiedades["mostrarTabla"]
                : false
              : false,
            label: "Mostrar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chModificarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["modificar_tabla"]
                ? control.propiedades["modificar_tabla"]
                : false
              : false,
            label: "Modificar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chSincronizar",
            type: "checkbox",
            value: control ? control.sincronizado : false,
            label: "Sincronizar",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chSinFiltro",
            type: "checkbox",
            value: control ? (control.propiedades["sin_filtro"] ? control.propiedades["sin_filtro"] : false) : false,
            label: "Sin filtro",
            size: this.table ? "col-12 col-md-3" : "",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chUnico",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["unico"] : false) : false,
            label: "Unico registro",
            size: this.table ? "col-12 col-md-3" : "d-none",
          }),
          new Textbox({
            key: "chCampoModificable",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["modificar_campo"] : false) : false,
            label: "Modificar campo",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Asignar valor",
                valorAsignar: false
              },
            ],
          })
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el formulario de creacion para los controles tipo Date
   *
   * @param {Array<EspacioControl>} sizesControl
   * @param {Control} [control]
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormDate(sizesControl: Array<EspacioControl>, control?: Control): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: "txtAlias",
        label: "Alias del control:",
        value: control ? control.alias : "",
        describe:
          "Nota: este alias se utiliza como referencia para poder acceder a cada campo del formulario " +
          "y no debe llevar espacios ni caracteres especiales.",
        order: 1,
        placeholder: "Alias del control",
        validations: {
          validators: [Validators.required, Validators.pattern("^[a-zA-Z_]*$")],
          messages: { pattern: "Caracteres invalidos: solo letras y guiones bajos" },
        },
      }),
      new Dropdown({
        key: "cboEspacios",
        label: "Tamaño del control:",
        value: control ? control.espacio : 4,
        options: this.setSizes(sizesControl),
        order: 2,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtLabel",
        label: "Título del control:",
        value: control ? control.label : "",
        order: 3,
        placeholder: "Título del control",
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtTooltip",
        label: "Tooltip del control:",
        value: control ? control.tooltip : "",
        order: 4,
        placeholder: "Tooltip del control",
      }),
      new Dropdown({
        key: "cboTypePicker",
        label: "Tipo:",
        value: control ? (control.propiedades["tipo"] ? control.propiedades["tipo"] : "calendar") : "calendar",
        options: [
          { key: "calendar", value: "Fecha" },
          { key: "timer", value: "Hora" },
          { key: "dateTimer", value: "Fecha y hora" },
          // { key: 'rangeDate', value: 'Rango de fecha' },
          // { key: 'rangeTime', value: 'Rango de tiempo' },
          // { key: 'range', value: 'Rango de fecha y hora' },
        ],
        order: 5,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Container({
        class: "form-row form-check form-check-inline col-12",
        order: 6,
        controls: [
          new DateTimePicker({
            key: "txtDesde",
            label: "Fecha desde:",
            pickerType: "calendar",
            value: control ? (control.propiedades["fechaDesde"] ? control.propiedades["fechaDesde"] : null) : null,
            size: "col-md-10",
            placeholder: "Seleccionar fecha desde donde se seleccionara",
            condictions: [
              {
                campoDepende: "cboTypePicker",
                siEs: "Igual",
                valor: "timer",
                accion: "Ocultar",
              },
              {
                campoDepende: "chFechaActualDesde",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
              },
            ],
          }),
          new Textbox({
            key: "chFechaActualDesde",
            type: "checkbox",
            value: control
              ? control.propiedades["fechaActualDesde"]
                ? control.propiedades["fechaActualDesde"]
                : null
              : null,
            label: "Fecha actual",
            size: "col-md-2",
          }),
        ],
      }),
      new Container({
        class: "form-row form-check form-check-inline col-12",
        order: 7,
        controls: [
          new DateTimePicker({
            key: "txtHasta",
            label: "Fecha hasta:",
            pickerType: "calendar",
            value: control ? (control.propiedades["fechaHasta"] ? control.propiedades["fechaHasta"] : null) : null,
            size: "col-md-10",
            placeholder: "Seleccionar fecha hasta donde se seleccionara",
            condictions: [
              {
                campoDepende: "cboTypePicker",
                siEs: "Igual",
                valor: "timer",
                accion: "Ocultar",
              },
              {
                campoDepende: "chFechaActualHasta",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
              },
            ],
          }),
          new Textbox({
            key: "chFechaActualHasta",
            type: "checkbox",
            value: control
              ? control.propiedades["fechaActualHasta"]
                ? control.propiedades["fechaActualHasta"]
                : null
              : null,
            label: "Fecha actual",
            size: "col-md-2",
          }),
        ],
      }),
      new Textbox({
        key: "txtTamanoColumna",
        label: "Tamaño de columna:",
        value: control ? (control.propiedades["tamano_columna"] ? control.propiedades["tamano_columna"] : null) : null,
        type: "number",
        order: 8,
        placeholder: "Ingrese el tamaño de la columna",
        describe: "El tamaño de la columna sera automatico de no ingresarlo en este campo",
        validations: {
          validators: [Validators.max(100), Validators.min(1)],
          messages: {
            max: "El tamaño de la columna no puede superar el 100%.",
            min: "El tamaño de la columna debe ser mayor al 0%.",
          },
        },
        condictions: [
          {
            campoDepende: "chMostrarEnTabla",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      new Container({
        class: "form-row",
        order: 9,
        controls: [
          new Textbox({
            key: "chInterno",
            type: "checkbox",
            value: control
              ? control.propiedades["campo_interno"]
                ? control.propiedades["campo_interno"]
                : false
              : false,
            label: "Campo interno",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chRequiered",
            type: "checkbox",
            value: control ? control.requerido : false,
            label: "Requerido",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chBloquear",
            type: "checkbox",
            value: control ? control.propiedades["bloquear"] : false,
            label: "Bloquear",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chReadOnly",
            type: "checkbox",
            value: control ? (control.propiedades["redonly"] ? control.propiedades["redonly"] : false) : false,
            label: "Solo lectura",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chMostrarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["mostrarTabla"]
                ? control.propiedades["mostrarTabla"]
                : false
              : false,
            label: "Mostrar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chModificarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["modificar_tabla"]
                ? control.propiedades["modificar_tabla"]
                : false
              : false,
            label: "Modificar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chSincronizar",
            type: "checkbox",
            value: control ? control.sincronizado : false,
            label: "Sincronizar",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chSinFiltro",
            type: "checkbox",
            value: control ? (control.propiedades["sin_filtro"] ? control.propiedades["sin_filtro"] : false) : false,
            label: "Sin filtro",
            size: this.table ? "col-12 col-md-3" : "",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chUnico",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["unico"] : false) : false,
            label: "Unico registro",
            size: this.table ? "col-12 col-md-3" : "d-none",
          }),
          new Textbox({
            key: "chCampoModificable",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["modificar_campo"] : false) : false,
            label: "Modificar campo",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Asignar valor",
                valorAsignar: false
              },
            ],
          })
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el formulario de creacion para los controles tipo Select con filtro
   *
   * @param {Array<EspacioControl>} sizesControl
   * @param {Array<TablaMaestra>} masterTables
   * @param {Control} [control]
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormSelect(
    sizesControl: Array<EspacioControl>,
    masterTables: Array<TablaMaestra>,
    customSerachs: Array<any>,
    templeteForm: any,
    control?: Control,
    optionsSelectColum?: Array<any>,
    optionsOther?: {}
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: "txtAlias",
        label: "Alias del control:",
        value: control ? control.alias : "",
        describe:
          "Nota: este alias se utiliza como referencia para poder acceder a cada campo del formulario " +
          "y no debe llevar espacios ni caracteres especiales.",
        order: 1,
        placeholder: "Alias del control",
        validations: {
          validators: [Validators.required, Validators.pattern("^[a-zA-Z_]*$")],
          messages: { pattern: "Caracteres invalidos: solo letras y guiones bajos" },
        },
      }),
      new Dropdown({
        key: "cboTipoCarga",
        label: "Fuente de datos:",
        options: this.getOptionFountSelect(),
        value: control ? (control.propiedades["tipo"] ? control.propiedades["tipo"] : "TablaMaestra") : "TablaMaestra",
        order: 2,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Dropdown({
        key: "cboTipoSelect",
        label: "Tipo Selector:",
        value: control
          ? control.propiedades["tipoSelector"]
            ? control.propiedades["tipoSelector"]
            : "EnLista"
          : "EnLista",
        options: [
          { key: "EnLista", value: "En lista" },
          { key: "EnModal", value: "En modal" },
        ],
        order: 3,
        validations: {
          validators: [Validators.required],
        },
        condictions: [
          {
            campoDepende: "cboTipoCarga",
            siEs: "Igual",
            valor: "Condicion",
            accion: "Ocultar",
          },
          // {
          //   campoDepende: "cboTipoCarga",
          //   siEs: "Igual",
          //   valor: "RadicadosSistema",
          //   accion: "Ocultar",
          // },
          {
            campoDepende: "cboTipoCarga",
            siEs: "Igual",
            valor: "ConsecutivosActas",
            accion: "Ocultar",
          },
        ],
      }),
      new Container({
        class: "form-row",
        order: 6,
        controls: [
          new Textbox({
            key: "chAgregar",
            type: "checkbox",
            value: control
              ? control.propiedades["accionesInModal"]
                ? control.propiedades["accionesInModal"]["agregarInModal"]
                  ? control.propiedades["accionesInModal"]["agregarInModal"]
                  : false
                : false
              : false,
            label: "Agregar registro",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "cboTipoSelect",
                siEs: "Igual",
                valor: "EnModal",
                accion: "Mostrar",
                operadorCondicion: "Y",
              },
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaMaestra",
                accion: "Mostrar",
              },
            ],
          }),
          new Textbox({
            key: "chModificar",
            type: "checkbox",
            value: control
              ? control.propiedades["accionesInModal"]
                ? control.propiedades["accionesInModal"]["modificarInModal"]
                  ? control.propiedades["accionesInModal"]["modificarInModal"]
                  : false
                : false
              : false,
            label: "Modificar registro",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "cboTipoSelect",
                siEs: "Igual",
                valor: "EnModal",
                accion: "Mostrar",
                operadorCondicion: "Y",
              },
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaMaestra",
                accion: "Mostrar",
              },
            ],
          }),
          new Textbox({
            key: "chEliminar",
            type: "checkbox",
            value: control
              ? control.propiedades["accionesInModal"]
                ? control.propiedades["accionesInModal"]["eliminarInModal"]
                  ? control.propiedades["accionesInModal"]["eliminarInModal"]
                  : false
                : false
              : false,
            label: "Eliminar registro",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "cboTipoSelect",
                siEs: "Igual",
                valor: "EnModal",
                accion: "Mostrar",
                operadorCondicion: "Y",
              },
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaMaestra",
                accion: "Mostrar",
              },
            ],
          }),
        ],
      }),
      new Dropdown({
        key: "cboEspacios",
        label: "Tamaño del control:",
        value: control ? control.espacio : 4,
        options: this.setSizes(sizesControl),
        order: 6,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtLabel",
        label: "Título del control:",
        value: control ? control.label : "",
        order: 7,
        placeholder: "Título del control",
        validations: {
          validators: [Validators.required],
        },
        condictions: [
          {
            campoDepende: "cboTipoCarga",
            siEs: "Igual",
            valor: "Condicion",
            accion: "Ocultar",
          },
        ],
      }),
      new Textbox({
        key: "txtPlaceholder",
        label: "Placeholder del control:",
        value: control ? control.placeholder : "",
        order: 8,
        placeholder: "Placeholder del control",
      }),
      new Textbox({
        key: "txtTooltip",
        label: "Tooltip del control:",
        value: control ? control.tooltip : "",
        order: 9,
        placeholder: "Tooltip del control",
      }),
      new Container({
        class: "form-row",
        order: 10,
        controls: [
          new Custom({
            key: "cboMasterTable",
            label: "Cargar información de la tabla Maestra:",
            template: templeteForm["ngSelectRefresMaster"],
            placeholder: "Seleccione la tabla maestra de donde se cargaran las opciones",
            options: this.setMasterTables(masterTables),
            value: control ? (control.lista_maestra.length ? control.lista_maestra[0].id : null) : null,
            validations: {
              validators: [Validators.required],
            },
            size: "col-12",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaMaestra",
                accion: "Mostrar",
              },
            ],
          }),
          new Custom({
            key: "selectColumn",
            label: "Columnas a mostrar de la maestra:",
            template: templeteForm["ngSelectTpl"],
            placeholder: "Columnas a mostrar de la maestra",
            value: control
              ? control.propiedades["columnas_seleccionadas"]
                ? control.propiedades["columnas_seleccionadas"]
                : null
              : null,
            options: optionsSelectColum,
            validations: {
              validators: [Validators.required],
            },
            size: "col-12",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaMaestra",
                accion: "Mostrar",
              },
            ],
          }),
          new Custom({
            key: "cboForm",
            label: "Forma de la tabla:",
            template: templeteForm["ngSelectFormulario"],
            options: optionsOther ? (optionsOther["forms"] ? optionsOther["forms"] : []) : [],
            value: control
              ? control.propiedades["cargar_tabla"]
                ? control.propiedades["cargar_tabla"]["form"]
                  ? control.propiedades["cargar_tabla"]["form"]
                  : ""
                : ""
              : "",
            validations: {
              validators: [Validators.required],
            },
            size: "col-12",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaForma",
                accion: "Mostrar",
              },
            ],
          }),
          new Custom({
            key: "cboFormulario",
            label: "Cargar información de la tabla:",
            template: templeteForm["ngSelectFormulario"],
            placeholder: "Seleccione el formulario de donde se cargaran las opciones",
            options: optionsOther ? (optionsOther["formularios"] ? optionsOther["formularios"] : []) : [],
            value: control
              ? control.propiedades["cargar_tabla"]
                ? control.propiedades["cargar_tabla"]["formulario"]
                  ? control.propiedades["cargar_tabla"]["formulario"]
                  : null
                : null
              : null,
            validations: {
              validators: [Validators.required],
            },
            size: "col-12",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaForma",
                accion: "Mostrar",
              },
            ],
          }),
          new Custom({
            key: "cboColumn",
            label: "Columnas a mostrar:",
            template: templeteForm["ngSelectTpl"],
            placeholder: "Seleccione las columnas a mostrar de la forma",
            options: optionsOther ? (optionsOther["columns"] ? optionsOther["columns"] : []) : [],
            value: control
              ? control.propiedades["cargar_tabla"]
                ? control.propiedades["cargar_tabla"]["column"]
                  ? control.propiedades["cargar_tabla"]["column"]
                  : null
                : null
              : null,
            validations: {
              validators: [Validators.required],
            },
            size: "col-12",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaForma",
                accion: "Mostrar",
              },
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "Tramites",
                accion: "Mostrar",
              },
            ],
          }),
          new Textbox({
            key: "txtAliasCondicion",
            label: "Alias condicion:",
            value: control ? (control.propiedades["condicion"] ? control.propiedades["condicion"] : null) : null,
            size: "col-12",
            placeholder: "Ingrese el alias de la condición.",
            validations: {
              validators: [Validators.required],
            },
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "Condicion",
                accion: "Mostrar",
              },
            ],
          }),
        ],
      }),
      new Textbox({
        key: "txtTamanoColumna",
        label: "Tamaño de columna:",
        value: control ? (control.propiedades["tamano_columna"] ? control.propiedades["tamano_columna"] : null) : null,
        type: "number",
        order: 11,
        placeholder: "Ingrese el tamaño de la columna",
        describe: "El tamaño de la columna sera automatico de no ingresarlo en este campo",
        validations: {
          validators: [Validators.max(100), Validators.min(1)],
          messages: {
            max: "El tamaño de la columna no puede superar el 100%.",
            min: "El tamaño de la columna debe ser mayor al 0%.",
          },
        },
        condictions: [
          {
            campoDepende: "chMostrarEnTabla",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      new Textbox({
        key: "chDynamicSelector",
        type: "checkbox",
        order: 12,
        value: control
          ? control.propiedades["campo_selector_dinamico"]
            ? control.propiedades["campo_selector_dinamico"]
            : false
          : false,
        label: "Selector dinámico",
        size: "col-12 col-md-3",
        condictions: [
          {
            campoDepende: "cboTipoCarga",
            siEs: "Igual",
            valor: "Tramites",
            accion: "Mostrar",
          },
        ],
      }),
      new Dropdown({
        key: "cboDynamicSelector",
        label: "Selector dinámico:",
        options: optionsOther ? (optionsOther["dynamic_selectors"] ? optionsOther["dynamic_selectors"] : []) : [],
        value: control
          ? control.propiedades["selector_dinamico"]
          : null,
        order: 13,
        validations: {
          validators: [Validators.required],
        },
        condictions: [
          {
            campoDepende: "chDynamicSelector",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      new Container({
        class: "form-row",
        order: 14,
        controls: [
          new Textbox({
            key: "chInterno",
            type: "checkbox",
            value: control
              ? control.propiedades["campo_interno"]
                ? control.propiedades["campo_interno"]
                : false
              : false,
            label: "Campo interno",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chRequiered",
            type: "checkbox",
            value: control ? control.requerido : false,
            label: "Requerido",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chBloquear",
            type: "checkbox",
            value: control ? control.propiedades["bloquear"] : false,
            label: "Bloquear",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chReadOnly",
            type: "checkbox",
            value: control ? (control.propiedades["redonly"] ? control.propiedades["redonly"] : false) : false,
            label: "Solo lectura",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chMostrarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["mostrarTabla"]
                ? control.propiedades["mostrarTabla"]
                : false
              : false,
            label: "Mostrar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
              {
                campoDepende: "chCampoGeneral",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chModificarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["modificar_tabla"]
                ? control.propiedades["modificar_tabla"]
                : false
              : false,
            label: "Modificar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chSincronizar",
            type: "checkbox",
            value: control ? control.sincronizado : false,
            label: "Sincronizar",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chSinFiltro",
            type: "checkbox",
            value: control ? (control.propiedades["sin_filtro"] ? control.propiedades["sin_filtro"] : false) : false,
            label: "Sin filtro",
            size: this.table ? "col-12 col-md-3" : "",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chValidarSede",
            type: "checkbox",
            value: control
              ? control.propiedades["validar_sede"]
                ? control.propiedades["validar_sede"]
                : false
              : false,
            label: "Validar Dependencia",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaMaestra",
                accion: "Mostrar",
              },
            ],
          }),
          new Textbox({
            key: "chGuardarMunicipio",
            type: "checkbox",
            value: control ? (control.propiedades["guardar_municipio"] ? true : false) : false,
            label: "Guardar municipio",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaMaestra",
                accion: "Mostrar",
              },
            ],
          }),
          new Textbox({
            key: "chCampoGeneral",
            type: "checkbox",
            value: control
              ? control.propiedades["columna_general"]
                ? control.propiedades["columna_general"]
                : false
              : false,
            label: "Columna general",
            size: this.table ? "col-12 col-md-3" : "d-none",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: false,
                accion: "Mostrar",
                operadorCondicion: "Y",
              },
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "TablaForma",
                accion: "Mostrar",
              },
            ],
          }),
          new Textbox({
            key: "chUnico",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["unico"] : false) : false,
            label: "Unico registro",
            size: this.table ? "col-12 col-md-3" : "d-none",
          }),
          new Textbox({
            key: "chAsociarDocumento",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["asociar_documentos"] : false) : false,
            label: "Asociar documento",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "Tramites",
                accion: "Mostrar",
              },
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "RadicadosSistema",
                accion: "Mostrar",
              },
              {
                campoDepende: "chComoAsociar",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              }
            ],
          }),
          new Textbox({
            key: "chComoAsociar",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["asociar_expediente"] : false) : false,
            label: "Asociar trámite",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "Tramites",
                accion: "Mostrar",
              },
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "RadicadosSistema",
                accion: "Ocultar",
              },
              {
                campoDepende: "chAsociarDocumento",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              }
            ],
          }),
          new Textbox({
            key: "chCampoModificable",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["modificar_campo"] : false) : false,
            label: "Modificar campo",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Asignar valor",
                valorAsignar: false
              },
            ],
          }),
          new Textbox({
            key: "chAutoAjustar",
            type: "checkbox",
            value: control ? (control.propiedades["auto_ajustar_tamano"] ? true : false) : false,
            label: "Auto ajustar tamaño del contenido",
            size: "col-12 col-md-3",
            condictions: [{
              campoDepende: "cboTipoSelect",
              siEs: "Igual",
              valor: "EnLista",
              accion: "Mostrar",
            },],
          }),
        ],
      }),
      new Custom({
        key: "selectColumnValid",
        label: "Columna a validar:",
        template: templeteForm["ngSelectTplOnly"],
        placeholder: "Seleccione la columna por la cual se validara la sede",
        describe: "Nota: Tener en cuenta que la columna seleccionada debe estar relacionada con la maestra municipios.",
        value: control
          ? control.propiedades["columna_validar_sede"]
            ? control.propiedades["columna_validar_sede"]
            : null
          : null,
        options: optionsOther["columnsMasterFilter"],
        validations: {
          validators: [Validators.required],
        },
        order: 15,
        condictions: [
          {
            campoDepende: "chValidarSede",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      new Custom({
        key: "selectColumnMunicipality",
        label: "Columna de municipio:",
        template: templeteForm["ngSelectTplOnly"],
        placeholder: "Seleccione la columna por la cual se guardara el municipio",
        describe: "Nota: Tener en cuenta que la columna seleccionada debe estar relacionada con la maestra municipios.",
        value: control
          ? control.propiedades["guardar_municipio"]
            ? control.propiedades["guardar_municipio"]
            : null
          : null,
        options: optionsOther["columnsMasterJurisdiccion"],
        validations: {
          validators: [Validators.required],
        },
        order: 15,
        condictions: [
          {
            campoDepende: "chGuardarMunicipio",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      new Container({
        class: "form-row",
        order: 16,
        controls: [
          new Textbox({
            key: "chConsultaAvanzada",
            type: "checkbox",
            value: control ? control.propiedades["consultaAvanzada"] : false,
            label: "Consulta avanzada",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "cboTipoCarga",
                siEs: "Igual",
                valor: "RadicadosSistema",
                accion: "Mostrar",
              },
            ],
          }),
          new Custom({
            key: "cboListaAvanzada",
            label: "Seleccionar consulta de documentos:",
            template: templeteForm["ngSelectRefresAdvanceSearch"],
            placeholder: "Seleccione la consulta personalizada",
            options: this.setMapSearch(customSerachs),
            value: control ? control.propiedades["consultaAvanzadaId"] : null,
            validations: {
              validators: [Validators.required],
            },
            size: "col-12",
            condictions: [
              {
                campoDepende: "chConsultaAvanzada",
                siEs: "Igual",
                valor: true,
                accion: "Mostrar",
              },
            ],
          }),
        ],
      }),
      new Textbox({
        key: "chAsociarProcedimientoFinalizacion",
        type: "checkbox",
        order: 17,
        value: control ? control.propiedades["asociarProcedimientoFinaizar"] : false,
        label: "Asociar tramite al finalizar la tarea",
        size: "col-12 col-md-3",
        condictions: [
          {
            campoDepende: "cboTipoCarga",
            siEs: "Igual",
            valor: "Tramites",
            accion: "Mostrar",
          },
          {
            campoDepende: "cboTipoCarga",
            siEs: "Igual",
            valor: "RadicadosSistema",
            accion: "Ocultar",
          },
          {
            campoDepende: "chComoAsociar",
            siEs: "Igual",
            valor: false,
            accion: "Ocultar",
          },
          {
            campoDepende: "chAsociarDocumento",
            siEs: "Igual",
            valor: true,
            accion: "Ocultar",
          }
        ],
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el formulario para la creacion de los controles de tipo input-email
   *
   * @param {Array<EspacioControl>} sizesControl
   * @param {Control} [control]
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormEmail(sizesControl: Array<EspacioControl>, control?: Control): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: "txtAlias",
        label: "Alias del control:",
        value: control ? control.alias : "",
        describe:
          "Nota: este alias se utiliza como referencia para poder acceder a cada campo del formulario " +
          "y no debe llevar espacios ni caracteres especiales.",
        order: 1,
        placeholder: "Alias del control",
        validations: {
          validators: [Validators.required, Validators.pattern("^[a-zA-Z_]*$")],
          messages: { pattern: "Caracteres invalidos: solo letras y guiones bajos" },
        },
      }),
      new Dropdown({
        key: "cboEspacios",
        label: "Tamaño del control:",
        value: control ? control.espacio : 4,
        options: this.setSizes(sizesControl),
        order: 2,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtLabel",
        label: "Título del control:",
        value: control ? control.label : "",
        order: 3,
        placeholder: "Título del control",
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtPlaceholder",
        label: "Placeholder del control:",
        value: control ? control.placeholder : "",
        order: 4,
        placeholder: "Placeholder del control",
      }),
      new Textbox({
        key: "txtTooltip",
        label: "Tooltip del control:",
        value: control ? control.tooltip : "",
        order: 5,
        placeholder: "Tooltip del control",
      }),
      new Textbox({
        key: "txtExpresion",
        label: "Expresion regular:",
        value: control ? (control.propiedades["expresion"] ? control.propiedades["expresion"] : "") : "",
        order: 6,
        placeholder: "Expresion regular",
      }),
      new Textbox({
        key: "txtErrorExp",
        label: "Mensaje de error:",
        value: control ? (control.propiedades["mensajeExpresion"] ? control.propiedades["mensajeExpresion"] : "") : "",
        order: 7,
        placeholder: "Mensaje de error de la expresion regular",
      }),
      new Textbox({
        key: "txtTamanoColumna",
        label: "Tamaño de columna:",
        value: control ? (control.propiedades["tamano_columna"] ? control.propiedades["tamano_columna"] : null) : null,
        type: "number",
        order: 8,
        placeholder: "Ingrese el tamaño de la columna",
        describe: "El tamaño de la columna sera automatico de no ingresarlo en este campo",
        validations: {
          validators: [Validators.max(100), Validators.min(1)],
          messages: {
            max: "El tamaño de la columna no puede superar el 100%.",
            min: "El tamaño de la columna debe ser mayor al 0%.",
          },
        },
        condictions: [
          {
            campoDepende: "chMostrarEnTabla",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      new Container({
        class: "form-row",
        order: 9,
        controls: [
          new Textbox({
            key: "chInterno",
            type: "checkbox",
            value: control
              ? control.propiedades["campo_interno"]
                ? control.propiedades["campo_interno"]
                : false
              : false,
            label: "Campo interno",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chRequiered",
            type: "checkbox",
            value: control ? control.requerido : false,
            label: "Requerido",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chBloquear",
            type: "checkbox",
            value: control ? control.propiedades["bloquear"] : false,
            label: "Bloquear",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chReadOnly",
            type: "checkbox",
            value: control ? (control.propiedades["redonly"] ? control.propiedades["redonly"] : false) : false,
            label: "Solo lectura",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chMostrarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["mostrarTabla"]
                ? control.propiedades["mostrarTabla"]
                : false
              : false,
            label: "Mostrar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chModificarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["modificar_tabla"]
                ? control.propiedades["modificar_tabla"]
                : false
              : false,
            label: "Modificar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chSincronizar",
            type: "checkbox",
            value: control ? control.sincronizado : false,
            label: "Sincronizar",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chSinFiltro",
            type: "checkbox",
            value: control ? (control.propiedades["sin_filtro"] ? control.propiedades["sin_filtro"] : false) : false,
            label: "Sin filtro",
            size: this.table ? "col-12 col-md-3" : "",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chUnico",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["unico"] : false) : false,
            label: "Unico registro",
            size: this.table ? "col-12 col-md-3" : "d-none",
          }),
          new Textbox({
            key: "chCampoModificable",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["modificar_campo"] : false) : false,
            label: "Modificar campo",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Asignar valor",
                valorAsignar: false
              },
            ],
          })
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el formulario para la creacion de los controles de tipo input-number
   *
   * @param {Array<EspacioControl>} sizesControl
   * @param {Control} [control]
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormNumber(sizesControl: Array<EspacioControl>, control?: Control): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: "txtAlias",
        label: "Alias del control:",
        value: control ? control.alias : "",
        describe:
          "Nota: este alias se utiliza como referencia para poder acceder a cada campo del formulario " +
          "y no debe llevar espacios ni caracteres especiales.",
        order: 1,
        placeholder: "Alias del control",
        validations: {
          validators: [Validators.required, Validators.pattern("^[a-zA-Z_]*$")],
          messages: { pattern: "Caracteres invalidos: solo letras y guiones bajos" },
        },
      }),
      new Dropdown({
        key: "cboEspacios",
        label: "Tamaño del control:",
        value: control ? control.espacio : 4,
        options: this.setSizes(sizesControl),
        order: 2,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtLabel",
        label: "Título del control:",
        value: control ? control.label : "",
        order: 3,
        placeholder: "Título del control",
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtPlaceholder",
        label: "Placeholder del control:",
        value: control ? control.placeholder : "",
        order: 4,
        placeholder: "Placeholder del control",
      }),
      new Textbox({
        key: "txtTooltip",
        label: "Tooltip del control:",
        value: control ? control.tooltip : "",
        order: 5,
        placeholder: "Tooltip del control",
      }),
      new Textbox({
        key: "txtMin",
        label: "Valor mínimo:",
        value: control ? (control.propiedades["min"] ? control.propiedades["min"] : null) : null,
        type: "number",
        order: 6,
        placeholder: "Valor mínimo",
      }),
      // Anexo dato radicación
      new Textbox({
        key: "txtRadicacion",
        label: "Dato radicación:",
        value: control ? control.dato_radicacion : "",
        order: 7,
        placeholder: "Dato radicación",
        validations: {
        },
      }),
      // Fin
      new Textbox({
        key: "chMayorQue",
        type: "checkbox",
        value: control ? (control.propiedades["mayorQue"] ? control.propiedades["mayorQue"] : false) : false,
        label: "Activar mayor Que",
        order: 8,
        condictions: [
          {
            campoDepende: "txtMin",
            siEs: "Vacio",
            accion: "Ocultar",
          },
        ],
      }),
      new Textbox({
        key: "txtMax",
        label: "Valor máximo:",
        value: control ? (control.propiedades["max"] ? control.propiedades["max"] : null) : null,
        type: "number",
        order: 9,
        placeholder: "Valor máximo",
      }),
      new Textbox({
        key: "chMenorQue",
        type: "checkbox",
        value: control ? (control.propiedades["menorQue"] ? control.propiedades["menorQue"] : false) : false,
        label: "Activar menor Que",
        order: 10,
        condictions: [
          {
            campoDepende: "txtMax",
            siEs: "Vacio",
            accion: "Ocultar",
          },
        ],
      }),
      new Textbox({
        key: "chSeparadorMiles",
        type: "checkbox",
        value: control ? (control.propiedades["separadorMiles"] ? true : false) : false,
        label: "Separador de miles",
        order: 11,
      }),
      new Container({
        class: "form-row",
        order: 12,
        controls: [
          new Dropdown({
            key: "cboSeparadorMiles",
            label: "Separador de miles:",
            value: control
              ? control.propiedades["separadorMiles"]
                ? control.propiedades["separadorMiles"]
                : ","
              : ",",
            options: [
              { value: ",", key: "," },
              { value: ".", key: "." },
            ],
            size: "col-md-6",
            validations: {
              validators: [Validators.required],
            },
            condictions: [
              {
                campoDepende: "chSeparadorMiles",
                siEs: "Igual",
                valor: "true",
                accion: "Mostrar",
              },
            ],
          }),
          new Dropdown({
            key: "cboSeparadorDecimales",
            label: "Separador de decimales:",
            value: control
              ? control.propiedades["separadorDecimales"]
                ? control.propiedades["separadorDecimales"]
                : "."
              : ".",
            options: [
              { value: ",", key: "," },
              { value: ".", key: "." },
            ],
            size: "col-md-6",
            validations: {
              validators: [Validators.required],
            },
            condictions: [
              {
                campoDepende: "chSeparadorMiles",
                siEs: "Igual",
                valor: "true",
                accion: "Mostrar",
              },
            ],
          }),
        ],
      }),
      new Textbox({
        key: "txtCantidadDecimales",
        label: "Cantidad de decimales:",
        value: control
          ? control.propiedades["cantidadDecimales"]
            ? control.propiedades["cantidadDecimales"]
            : null
          : null,
        type: "number",
        order: 13,
        placeholder: "Valor máximo",
        condictions: [
          {
            campoDepende: "chEnteros",
            siEs: "Igual",
            valor: true,
            accion: "Ocultar",
          },
        ],
      }),
      new Container({
        class: "form-row",
        order: 14,
        controls: [
          new Textbox({
            key: "chRoundFloorDecimal",
            type: "checkbox",
            value: control
              ? control.propiedades["roundFloorDecimal"]
                ? control.propiedades["roundFloorDecimal"]
                : false
              : false,
            label: "Redondear hacia abajo los decimales",
            size: "col-12 col-md-4",
            condictions: [
              {
                campoDepende: "chRoundDecimal",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
                operadorCondicion: "O",
              },
              {
                campoDepende: "chRoundCeilDecimal",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
              },
              {
                campoDepende: "chEnteros",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chRoundDecimal",
            type: "checkbox",
            value: control
              ? control.propiedades["roundDecimal"]
                ? control.propiedades["roundDecimal"]
                : false
              : false,
            label: "Redondear por exceso los decimales",
            size: "col-12 col-md-4",
            condictions: [
              {
                campoDepende: "chRoundFloorDecimal",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
                operadorCondicion: "O",
              },
              {
                campoDepende: "chRoundCeilDecimal",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
              },
              {
                campoDepende: "chEnteros",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chRoundCeilDecimal",
            type: "checkbox",
            value: control
              ? control.propiedades["roundCeilDecimal"]
                ? control.propiedades["roundCeilDecimal"]
                : false
              : false,
            label: "Redondear hacia arriba los decimales",
            size: "col-12 col-md-4",
            condictions: [
              {
                campoDepende: "chRoundFloorDecimal",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
                operadorCondicion: "O",
              },
              {
                campoDepende: "chRoundDecimal",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
              },
              {
                campoDepende: "chEnteros",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
        ],
      }),
      new Textbox({
        key: "txtExpresion",
        label: "Expresion regular:",
        value: control ? (control.propiedades["expresion"] ? control.propiedades["expresion"] : "") : "",
        order: 15,
        placeholder: "Expresion regular",
      }),
      new Textbox({
        key: "txtErrorExp",
        label: "Mensaje de error:",
        value: control ? (control.propiedades["mensajeExpresion"] ? control.propiedades["mensajeExpresion"] : "") : "",
        order: 16,
        placeholder: "Mensaje de error de la expresion regular",
      }),
      new Textbox({
        key: "chEnteros",
        type: "checkbox",
        label: "Numeros enteros",
        value: control ? (control.propiedades["enteros"] ? control.propiedades["enteros"] : false) : false,
        order: 17,
      }),
      new Legend({
        value: "Redondear operaciones:",
        order: 18,
      }),
      new Container({
        class: "form-row",
        order: 19,
        controls: [
          new Textbox({
            key: "chRoundFloor",
            type: "checkbox",
            value: control ? (control.propiedades["roundFloor"] ? control.propiedades["roundFloor"] : false) : false,
            label: "Redondear hacia abajo",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chRound",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
                operadorCondicion: "O",
              },
              {
                campoDepende: "chRoundCeil",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
              },
            ],
          }),
          new Textbox({
            key: "chRound",
            type: "checkbox",
            value: control ? (control.propiedades["round"] ? control.propiedades["round"] : false) : false,
            label: "Redondear por exceso",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chRoundFloor",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
                operadorCondicion: "O",
              },
              {
                campoDepende: "chRoundCeil",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
              },
            ],
          }),
          new Textbox({
            key: "chRoundCeil",
            type: "checkbox",
            value: control ? (control.propiedades["roundCeil"] ? control.propiedades["roundCeil"] : false) : false,
            label: "Redondear hacia arriba",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chRoundFloor",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
                operadorCondicion: "O",
              },
              {
                campoDepende: "chRound",
                siEs: "Igual",
                valor: "true",
                accion: "Bloquear",
              },
            ],
          }),
        ],
      }),
      new Legend({
        value: "Propiedades del control:",
        order: 20,
      }),
      new Textbox({
        key: "txtTamanoColumna",
        label: "Tamaño de columna:",
        value: control ? (control.propiedades["tamano_columna"] ? control.propiedades["tamano_columna"] : null) : null,
        type: "number",
        order: 21,
        placeholder: "Ingrese el tamaño de la columna",
        describe: "El tamaño de la columna sera automatico de no ingresarlo en este campo",
        validations: {
          validators: [Validators.max(100), Validators.min(1)],
          messages: {
            max: "El tamaño de la columna no puede superar el 100%.",
            min: "El tamaño de la columna debe ser mayor al 0%.",
          },
        },
        condictions: [
          {
            campoDepende: "chMostrarEnTabla",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      new Container({
        class: "form-row",
        order: 22,
        controls: [
          new Textbox({
            key: "chInterno",
            type: "checkbox",
            value: control
              ? control.propiedades["campo_interno"]
                ? control.propiedades["campo_interno"]
                : false
              : false,
            label: "Campo interno",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chRequiered",
            type: "checkbox",
            value: control ? control.requerido : false,
            label: "Requerido",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chBloquear",
            type: "checkbox",
            value: control ? control.propiedades["bloquear"] : false,
            label: "Bloquear",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chReadOnly",
            type: "checkbox",
            value: control ? (control.propiedades["redonly"] ? control.propiedades["redonly"] : false) : false,
            label: "Solo lectura",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chMostrarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["mostrarTabla"]
                ? control.propiedades["mostrarTabla"]
                : false
              : false,
            label: "Mostrar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chModificarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["modificar_tabla"]
                ? control.propiedades["modificar_tabla"]
                : false
              : false,
            label: "Modificar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chSincronizar",
            type: "checkbox",
            value: control ? control.sincronizado : false,
            label: "Sincronizar",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chSinFiltro",
            type: "checkbox",
            value: control ? (control.propiedades["sin_filtro"] ? control.propiedades["sin_filtro"] : false) : false,
            label: "Sin filtro",
            size: this.table ? "col-12 col-md-3" : "",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chUnico",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["unico"] : false) : false,
            label: "Unico registro",
            size: this.table ? "col-12 col-md-3" : "d-none",
          }),
          new Textbox({
            key: "chCampoModificable",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["modificar_campo"] : false) : false,
            label: "Modificar campo",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Asignar valor",
                valorAsignar: false
              },
            ],
          })
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el formulario para la creacion de los controles de tipo label
   *
   * @param {Array<EspacioControl>} sizesControl
   * @param {Control} [control]
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormLabel(sizesControl: Array<EspacioControl>, control?: Control): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: "txtAlias",
        label: "Alias del control:",
        value: control ? control.alias : "",
        describe:
          "Nota: este alias se utiliza como referencia para poder acceder a cada campo del formulario " +
          "y no debe llevar espacios ni caracteres especiales.",
        order: 1,
        placeholder: "Alias del control",
        validations: {
          validators: [Validators.required, Validators.pattern("^[a-zA-Z_]*$")],
          messages: { pattern: "Caracteres invalidos: solo letras y guiones bajos" },
        },
      }),
      new Dropdown({
        key: "cboEspacios",
        label: "Tamaño del control:",
        value: control ? control.espacio : 4,
        options: this.setSizes(sizesControl),
        order: 2,
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtLabel",
        label: "Título:",
        value: control ? control.label : "",
        order: 3,
        placeholder: "Título",
        validations: {
          validators: [Validators.required],
        },
      }),
      new Dropdown({
        key: "cboSize",
        label: "Tamaño de fuente:",
        options: [
          { key: "2", value: "Grande" },
          { key: "4", value: "Mediano" },
          { key: "6", value: "Pequeño" },
        ],
        value: control ? (control.propiedades["sizeFont"] ? control.propiedades["sizeFont"] : "2") : "2",
        order: 4,
        validations: {
          validators: [Validators.required],
        },
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el formulario de creacion para los controles tipo Coordenadas
   *
   * @param {Control} [control]
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormCoordinates(control?: Control): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: "txtAlias",
        label: "Alias del control:",
        value: control ? control.alias : "",
        describe:
          "Nota: este alias se utiliza como referencia para poder acceder a cada campo del formulario " +
          "y no debe llevar espacios ni caracteres especiales.",
        order: 1,
        placeholder: "Alias del control",
        validations: {
          validators: [Validators.required, Validators.pattern("^[a-zA-Z_]*$")],
          messages: { pattern: "Caracteres invalidos: solo letras y guiones bajos" },
        },
      }),
      new Textbox({
        key: "txtLabel",
        label: "Título del control:",
        value: control ? control.label : "",
        order: 2,
        placeholder: "Título del control",
        validations: {
          validators: [Validators.required],
        },
      }),
      new Textbox({
        key: "txtTamanoColumna",
        label: "Tamaño de columna:",
        value: control ? (control.propiedades["tamano_columna"] ? control.propiedades["tamano_columna"] : null) : null,
        type: "number",
        order: 3,
        placeholder: "Ingrese el tamaño de la columna",
        describe: "El tamaño de la columna sera automatico de no ingresarlo en este campo",
        validations: {
          validators: [Validators.max(100), Validators.min(1)],
          messages: {
            max: "El tamaño de la columna no puede superar el 100%.",
            min: "El tamaño de la columna debe ser mayor al 0%.",
          },
        },
        condictions: [
          {
            campoDepende: "chMostrarEnTabla",
            siEs: "Igual",
            valor: true,
            accion: "Mostrar",
          },
        ],
      }),
      new Container({
        class: "form-row",
        order: 4,
        controls: [
          new Textbox({
            key: "chInterno",
            type: "checkbox",
            value: control
              ? control.propiedades["campo_interno"]
                ? control.propiedades["campo_interno"]
                : false
              : false,
            label: "Campo interno",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chRequiered",
            type: "checkbox",
            value: control ? control.requerido : false,
            label: "Requerido",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chBloquear",
            type: "checkbox",
            value: control ? control.propiedades["bloquear"] : false,
            label: "Bloquear",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chReadOnly",
            type: "checkbox",
            value: control ? (control.propiedades["redonly"] ? control.propiedades["redonly"] : false) : false,
            label: "Solo lectura",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chMostrarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["mostrarTabla"]
                ? control.propiedades["mostrarTabla"]
                : false
              : false,
            label: "Mostrar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chModificarEnTabla",
            type: "checkbox",
            value: control
              ? control.propiedades["modificar_tabla"]
                ? control.propiedades["modificar_tabla"]
                : false
              : false,
            label: "Modificar en tabla",
            size: "col-12 col-md-3",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chSincronizar",
            type: "checkbox",
            value: control ? control.sincronizado : false,
            label: "Sincronizar",
            size: "col-12 col-md-3",
          }),
          new Textbox({
            key: "chSinFiltro",
            type: "checkbox",
            value: control ? (control.propiedades["sin_filtro"] ? control.propiedades["sin_filtro"] : false) : false,
            label: "Sin filtro",
            size: this.table ? "col-12 col-md-3" : "",
            hidden: !this.table,
            condictions: [
              {
                campoDepende: "chInterno",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
            ],
          }),
          new Textbox({
            key: "chUnico",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["unico"] : false) : false,
            label: "Unico registro",
            size: this.table ? "col-12 col-md-3" : "d-none",
          }),
          new Textbox({
            key: "chCampoModificable",
            type: "checkbox",
            value: control ? (control.propiedades ? control.propiedades["modificar_campo"] : false) : false,
            label: "Modificar campo",
            size: "col-12 col-md-3",
            condictions: [
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Ocultar",
              },
              {
                campoDepende: "chReadOnly",
                siEs: "Igual",
                valor: true,
                accion: "Asignar valor",
                valorAsignar: false
              },
            ],
          })
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Retorna el formualrio de la fuente de datos de las tablas
   *
   * @param {SubForma} form
   * @param {*} optionsOther
   * @param {*} templeteForm
   * @returns {BaseControl<any>[]}
   * @memberof CreationFormsFormService
   */
  getFormFountDataTable(form: SubForma, optionsOther: any, templeteForm: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: "cboForm",
        template: templeteForm,
        label: "Forma de la tabla:",
        placeholder: "Seleccione la forma de la tabla de carga de datos.",
        options: optionsOther ? (optionsOther["forms"] ? optionsOther["forms"] : []) : [],
        value: form
          ? form.estilo["fuente"]
            ? form.estilo["fuente"]["form"]
              ? form.estilo["fuente"]["form"]
              : null
            : null
          : null,
        size: "col-12",
      }),
      new Custom({
        key: "cboFormulario",
        label: "Cargar información de la tabla:",
        template: templeteForm,
        placeholder: "Seleccione la tabla de donde se cargaran los datos",
        options: optionsOther ? (optionsOther["formularios"] ? optionsOther["formularios"] : []) : [],
        describe:
          "Nota: La columna de la forma actual donde se desea llamar una de las columnas " +
          "de la fuente de datos debe llevar el mismo alias que dicha columna que se desea cargar.",
        value: form
          ? form.estilo["fuente"]
            ? form.estilo["fuente"]["formulario"]
              ? form.estilo["fuente"]["formulario"]
              : null
            : null
          : null,
        validations: {
          validators: [Validators.required],
        },
        size: "col-12",
        condictions: [
          {
            campoDepende: "cboForm",
            siEs: "Vacio",
            accion: "Ocultar",
          },
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Retorna las opciones de la fuente de datos de los campos dinamicos
   * de tipo selector con filtro
   *
   * @memberof CreationFormsFormService
   */
  getOptionFountSelect(): Option[] {
    const options: Option[] = [
      { key: "TablaMaestra", value: "Tabla Maestra" },
      { key: "TablaForma", value: "Tabla Forma" },
      { key: "Condicion", value: "Condicion" },
      { key: "RadicadosSistema", value: "Radicados del sistema" },
      { key: "Tramites", value: "Trámites" },
      { key: "TipoDocumental", value: "Tipo documental" },
    ];
    if (environment.actasAUCTIFF) {
      options.push({ key: "ConsecutivosActas", value: "Consecutivos AUCTIFF" });
    }
    return options;
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/shared/creation-forms-form.service.ts